import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HeaderModule } from './components/header/header.module';
import { SwiperCarouselModule } from './components/swiper-carousel/swiper-carousel.module';

import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS, // ⬅ add this
} from '@angular/common/http';

import { APP_CONFIG, BaseAppConfig } from './app.config';
import { environment } from 'src/environments/environment';

import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app'; // ⬅ getApp
import {
  provideAuth,
  initializeAuth, // ⬅ use initializeAuth instead of getAuth
  indexedDBLocalPersistence, // ⬅ durable persistence (best on modern WebViews)
  browserLocalPersistence, // ⬅ fallback
} from '@angular/fire/auth';

import { IonicStorageModule } from '@ionic/storage-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

// ⬇️ import your interceptor
import { AuthTokenInterceptor } from './services/auth/auth-token.interceptor';
// import { ServiceWorkerModule } from '@angular/service-worker';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HeaderModule,
    SwiperCarouselModule,
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   // Register the ServiceWorker as soon as the application is stable
    //   // or after 30 seconds (whichever comes first).
    //   registrationStrategy: 'registerWhenStable:10000'
    // }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: APP_CONFIG, useValue: BaseAppConfig },
    {
      provide: TranslateHttpLoader,
      useValue: {
        prefix: './assets/i18n/',
        suffix: '.json',
      },
    },
    // ✅ Initialize Firebase app
    provideFirebaseApp(() => initializeApp(environment.global.firebaseConfig)),

    // ✅ Make auth persistent (IndexedDB, fallback to localStorage)
    provideAuth(() =>
      initializeAuth(getApp(), {
        persistence: [indexedDBLocalPersistence, browserLocalPersistence],
      })
    ),

    // // ✅ Attach interceptor so every API call gets a fresh ID token
    // { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },

    // provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
